import { Reveal } from "@/components/Reveal";

export const SectionHeading = ({ index, overline, title, sub, align = "left" }) => (
  <Reveal className={`mb-10 sm:mb-14 ${align === "center" ? "text-center" : ""}`}>
    {overline && (
      <p className="mb-3 text-xs font-semibold uppercase tracking-[0.22em] text-neutral-400" data-testid="section-overline">
        {index && <span className="mr-2 font-serif italic text-neutral-500">{index}</span>}
        {overline}
      </p>
    )}
    <h2 className="font-heading text-2xl font-bold tracking-tight text-neutral-900 sm:text-3xl lg:text-4xl">{title}</h2>
    {sub && <p className={`mt-3 max-w-xl text-sm leading-relaxed text-neutral-500 sm:text-base ${align === "center" ? "mx-auto" : ""}`}>{sub}</p>}
  </Reveal>
);
